/*
    Filter for choosing which bus trip records to display,
    based on location, routes, lanes, and a time range (either explicitly or as lookahead/behind)

    If a user has previously selected a location and/or lanes, those will be populated on load
*/

import React from "react";

import Constants from "../Constants";
import MainContext from "../MainContext";

import DateInput from "../Components/DateInput";

import MultiSelect from "../Components/MultiSelect";

import TimeInput from "../Components/TimeInput";

import LocationDropDown from "../Components/LocationDropDown";

import { getRoutes, getLanes } from "../Requests/UtilityRequests";

import { getTimeStringFromDate, getCurrentDateWithMinutesAdded } from "../Scripts/Utilities";

/*
Location
Lanes
Route
Date Rate

(no Date Range or Route for starters - instead send a fixed value for Dates)
*/

// times in minutes to fill in the lookahead/lookbehind dropdowns with
const lookOptions = [30, 60, 90, 120, 150, 180];

//
// default value for the filter
// to use initially and also when the user chooses to reset
//
function getDefaultState(user) {

    let lookBehind = user.lookbehind ? 1 * user.lookbehind : 30;
    let lookAhead = user.lookahead ? 1 * user.lookahead : 60;

    const start = getCurrentDateWithMinutesAdded(lookBehind);
    const end = getCurrentDateWithMinutesAdded(lookAhead);

    // non-starters will have to choose specific time ranges rather than
    // a lookahead/behind based on the current time
    if(user && user.access !== Constants.access.starter){
        console.log("LOOKAHEAD CHANGED TO ZERO");
        lookAhead = 0;
        lookBehind = 0;
    }
    else{
        console.log("NO LOOKAHEAD OVERWRITE", user, user.access);
    }

    return {
        startDate: start,
        endDate: end,
        startHour: 10,
        lookBehind,
        lookBehindChanged: false,
        lookAhead,
        startTime: getTimeStringFromDate(start),
        endTime: getTimeStringFromDate(end),
        location: "",
        locationError: false,
        routes: [],
        routesSelected: [],
        lanes: [],
        lanesSelected: []
    };
}

export default class BusOpsFilter extends React.Component {

    static contextType = MainContext;

    constructor(){
        super();
        console.log("FILTER LOAD PROPS", this.props);
        this.state = getDefaultState({});
    }

    //
    //
    updateValue = (evt) => {
        const {name} = evt.target;
        this.setState({[evt.target.name]: evt.target.value}, () => {
            if(name === "location"){
                // get routes and lanes
                this.locationSelected();
            }
            else if(name === "lookBehind"){
                this.setState({lookBehindChanged: true});
            }
        });
    }

    //
    //
    applyFilter = () => {
        if(this.state.location === ""){
            this.setState({locationError: true});
        }
        else{
            this.setState({locationError: false}, () => {
                const values = {...this.state};
                this.props.applyFilter(values, this.props.toggleFilter);
            });
        }
    }

    //
    //
    resetFilter = () => {
        const newFilter = getDefaultState(this.context.user);
        newFilter.location = this.state.location;
        newFilter.routes = this.state.routes;
        newFilter.lanes = this.state.lanes;
        this.setState(newFilter);
    }

    //
    // when a location is selected, fill in the associated routes and lanes
    //
    locationSelected = () => {
        this.fillRoutes();
        console.log("ABOUT TO FILL LANES");
        this.fillLanes();
    }
    
    //
    // when a route is selected, fill in the associated lanes
    //
    routeSelected = () => {
        this.fillLanes();
    }

    //
    //
    fillRoutes = () => {
        const request = () => getRoutes(this.state.location);
        const then = ({data}) => {
            const cleaned = data.map(v => v.Route);
            this.setState({routes: cleaned, routesSelected: []});
        };
        this.context.runProcessing(request, then, "getRoutes");
    }

    //
    //
    fillLanes = () => {
        const request = () => getLanes({location: this.state.location, route: this.state.routesSelected.join(",")});
        const then = ({data}) => {
            const cleaned = data.map(v => v.laneGate);
            const userLanes = this.getUserLanes();
            console.log("user lanes", userLanes);
            this.setState({lanes: cleaned, lanesSelected: userLanes});
        };
        this.context.runProcessing(request, then, "getRoutes");
    }

    //
    // get the lanes which are part of the user's existing settings
    //
    getUserLanes = () => {
        let lanesList = [];

        console.log("the user object", this.context.user);

        const userLocations = this.context.user.locationData;

        for(const loc of userLocations){
            if(loc.location_id === this.state.location){
                lanesList = loc.assigned_lane_gate;
                break;
            }
        }

        return lanesList;
    }

    //
    // in case there are any spurious DB records returned with blank values
    //
    removeExtraneousLanes(values){
        const newLanesSelected = [];

        console.log("REMOVE EXTRANEOUS");

        values.lanesSelected.forEach(ls => {
            for(let i = 0; i < values.lanes.length; i++){
                if(values.lanes[i] === ls){
                    console.log("LANE MATCH", ls);
                    newLanesSelected.push(ls);
                    break;
                }
            }
        });

        values.lanesSelected = newLanesSelected;
    }

    //
    // set the filter values
    //
    componentDidMount(){
        if(this.props.filterValues){
            console.log("WE GOT FILTER VALUES", this.props.filterValues);
            const copy = {...this.props.filterValues};
            if(this.context.user && this.context.user.access !== Constants.access.starter){
                copy.lookBehind = 0;
                copy.lookAhead = 0;
            }
            // else if(this.props.mode === "DEPARTED" && this.context.user && this.context.user.access === Constants.access.starter){
            //     copy.lookBehind = 60;
            // }
            this.removeExtraneousLanes(copy);
            this.setState(copy);
        }
        else{
            console.log("RESET THE DEFAULT STATE WITH THE USER", this.context.user);
            this.setState(getDefaultState(this.context.user));
        }
    }

    //
    //
    //
    render(){

        let lookBehindToUse = this.state.lookBehind;

        console.log("FILTER PROPS MODE", this.props.mode);
        const isDeparted = this.props.mode === "DEPARTED";

        if(isDeparted 
            && !this.state.lookBehindChanged
            && this.context
            && this.context.user.access === Constants.access.starter
        ){
            // default to 60 in this case
            lookBehindToUse = 60; 
        }

        // console.log("FILTER STATE", this.state);

        const style = this.state && this.state.locationError 
        ? {backgroundColor: "var(--red)"}
        : {};

        const isBus = this.context.user.groupid === "BUS";

        return (
            <div className="filter">
                <div id="busops_filter_location" className="filter-field form-element-horizontal" style={style}>
                    <label>Location</label>
                    <LocationDropDown 
                        setFocus={true}
                        selected={this.state.location}
                        updateValue={this.updateValue}
                    />
                </div>
                {
                    this.state.locationError
                    ? <div style={{
                        color: "var(--red)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        Location is Required
                    </div>
                    : null
                }
                {
                    // starter won't be selecting routes
                    this.context.user.access !== Constants.access.starter
                    ? <>
                    {
                        isBus
                        ? <div className="filter-field form-element-horizontal">
                            <label>Routes</label>
                            <MultiSelect 
                                name="routesSelected"
                                selected={this.state.routesSelected} 
                                options={this.state.routes} 
                                onChange={this.updateValue}
                                dataColumns={8}
                                onDone={this.routeSelected}
                            />
                        </div>
                        : null
                    }
                    <div className="filter-field form-element-horizontal">
                        <label>Start Date</label>
                        <div id="busops_filter_startdate">
                            <DateInput 
                                name="startDate"
                                value={this.state.startDate} 
                                onChange={this.updateValue} 
                            />
                            <TimeInput name="startTime" value={this.state.startTime} onChange={this.updateValue} />
                        </div>
                    </div>
                    <div className="filter-field form-element-horizontal">
                        <label>End Date</label>
                        <div id="busops_filter_enddate">
                            <DateInput 
                                name="endDate"
                                value={this.state.endDate} 
                                onChange={this.updateValue} 
                            />
                            <TimeInput name="endTime" value={this.state.endTime} onChange={this.updateValue} />
                        </div>
                    </div>
                    </>
                    : <div className="filter-field form-element-horizontal">
                        <label>Time Range</label>
                        <div style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr"
                        }}>
                            <div>
                                <label className="bold-label">Look Behind</label>
                                <select name="lookBehind" value={this.state.lookBehind} onChange={this.updateValue}>
                                {
                                    lookOptions.map((v, index) => {
                                        return <option key={index} value={v}>{v}</option>
                                    })
                                }
                                </select>
                            </div>
                            <div>
                                <label className="bold-label">Look Ahead</label>
                                <select name="lookAhead" value={this.state.lookAhead} onChange={this.updateValue}>
                                {
                                    lookOptions.map((v, index) => {
                                        return <option key={index} value={v}>{v}</option>
                                    })
                                }
                                </select>
                            </div>
                        </div>
                    </div>
                }

                {
                    isBus
                    ? <>
                        <div className="filter-field form-element-horizontal portrait-only">
                            <label>Lanes</label>
                            <MultiSelect 
                                name="lanesSelected"
                                selected={this.state.lanesSelected} 
                                options={this.state.lanes} 
                                onChange={this.updateValue}
                                dataColumns={8}
                                displayColumns={4}
                            />
                        </div>
                        <div className="filter-field form-element-horizontal landscape-only">
                            <label>Lanes</label>
                            <MultiSelect 
                                name="lanesSelected"
                                selected={this.state.lanesSelected} 
                                options={this.state.lanes} 
                                onChange={this.updateValue}
                                dataColumns={this.state.location === "PABT" ? 14 : 8}
                                displayColumns={4}
                            />
                        </div>
                    </>
                    : null
                }

                <div className="filter-bar">
                    <div className="option  " onClick={this.resetFilter}>Reset</div>
                    <div id="busops_apply_filter" className="option  " onClick={this.applyFilter}>Apply Filter</div>
                </div>
            </div>
        )
    }
}